import { html } from '@shared/utils/rendering/html';
import Button from '@shared/components/buttons';
import { Icon } from '@shared/components/icons';

const handleReload = () => window.location.reload();

const ErrorScreen = ({ error, details }) => {
    const config = window.__APP_CONFIG__ || {};
    const isDevelopment = config.ENVIRONMENT === 'Development' || config.ENVIRONMENT === 'Local';

    if (isDevelopment) {
        return html`<div class="error-screen error-screen--detailed">
            <div class="error-screen__content">
                <div class="error-screen__icon">
                    <${Icon} name="error" />
                </div>
                <div class="error-screen__message">
                    <h3 class="error-screen__title">
                        Failed to Load ${details?.title || 'Application'}
                    </h3>
                    <p class="error-screen__subtitle">
                        An error occurred while loading this module
                    </p>
                </div>
                <div class="error-screen__details">
                    <div class="error-screen__error-badge">Error Details</div>
                    <pre class="error-screen__stack">
                        ${error?.message || error?.toString() || 'Unknown error'}
                    </pre>
                    ${
                        error?.stack
                            ? html`<pre class="error-screen__stack">${error.stack}</pre>`
                            : null
                    }
                </div>
            </div>
        </div>`;
    }

    return html`<div class="error-screen error-screen--simple">
        <div class="error-screen__content">
            <div class="error-screen__icon">
                <${Icon} name="error" />
            </div>
            <div class="error-screen__message">
                <h3 class="error-screen__title">Unable to Load Module</h3>
                <p class="error-screen__subtitle">
                    We're having trouble loading this content. Please try refreshing the page.
                </p>
            </div>
            <${Button}
                buttonType="primary"
                css="error-screen__action"
                label=${{ text: 'Refresh Page' }}
                onClick=${handleReload}
            />
        </div>
    </div>`;
};

export default ErrorScreen;
